import { MoongateLogoColor } from "@assets";
import Image from "next/image";
import { ImArrowUp } from "react-icons/im";

const CreateWalletInstruction = () => {
  return (
    <div className="w-screen h-screen flex flex-col items-center text-center">
      <div className="mt-[15vh] text-3xl p-8">
        <ImArrowUp />
      </div>
      <p className="p-4 text-lg">
        Moongate is currently creating a new{" "}
        <b className="text-primary">non-custodial crypto wallet</b> linked to
        your email for you.
      </p>
      <p className="p-4 text-lg">
        Please <b className="text-primary font-bold">"Allow"</b> pop-up window
        or click <b className="text-primary font-bold">"Continue"</b> on the
        "Approve Pop-up" window to proceed.
      </p>
      <p className="p-4 text-neutral-100 font-light italic">
        If the pop-up window does not appear, please ensure that pop-up windows
        are enabled for this site and that you are not in Incognito Mode.
      </p>
      <div className="w-32 mt-8">
        <Image src={MoongateLogoColor} layout="responsive" />
      </div>
    </div>
  );
};

export default CreateWalletInstruction;
